import z from 'zod';
export const firmDocumentTemplateIdValue = z.string().trim().min(1)
    .brand('FirmDocumentTemplateId');
export const createFirmDocumentTemplateId = (value) => firmDocumentTemplateIdValue.parse(value);
export const isFirmDocumentTemplateId = (value) => firmDocumentTemplateIdValue.safeParse(value).success;
//# sourceMappingURL=ids.js.map